module.exports = __webpack_public_path__ + "img/product-shansuan-zsyy-03.c327a1bd.png";